<p-password [formControl]="control"
            placeholder="***************"
            [toggleMask]="true"
>
  <ng-template pTemplate="header">
    <h6 class="mb-2">Pick a password</h6>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-divider></p-divider>
    <p class="text--sm mt-2">Suggestions</p>
    <ul class="text--xs pl-2 ml-2 mt-1" style="list-style-type: disc;line-height: 1.5">
      <li>At least one lowercase</li>
      <li>At least one uppercase</li>
      <li>At least one numeric</li>
      <li>Minimum 8 characters</li>
    </ul>
  </ng-template>
</p-password>
